import React, { useContext } from 'react';
import { TiDelete } from 'react-icons/ti';
import Quantity from '../../Components/Quantity/Quantity';
import { CartContext } from '../../Context/CartContext/CartContext';
import { DECREASE_QUANTITY, INCREASE_QUANTITY, REMOVE_CART_ITEM } from '../../Context/Reducers/cartReducer';
import styles from './CartPage.module.scss';

interface Props {
  index: number,
  title: string,
  quantity: number,
}
const CartDescription = ({ title, quantity, index }: Props) => {
  const { dispatch } = useContext(CartContext);

  const handleAddQty = () => dispatch({ type: INCREASE_QUANTITY, payload: index });

  const handleDeductQty = () => dispatch({ type: DECREASE_QUANTITY, payload: index });
  const handleDelete = () => dispatch({ type: REMOVE_CART_ITEM, payload: index });

  return (
    <div>
      {title}
      <div className={styles.remove} onClick={handleDelete} aria-hidden>
        <TiDelete />
        {' '}
        Remove
      </div>
      <div className={styles.container}>
        <div className={styles.quantity}>
          <Quantity
            quantity={quantity}
            handleQtyAdd={handleAddQty}
            handleQtyDeduct={handleDeductQty}
            disableTitle={false}
          />
        </div>
      </div>
    </div>
  );
};

export default CartDescription;
